import { defineMessages } from 'react-intl';
import { SchedaPersonaWrapperView, HomeView, StrutturaView, HomeStrutturaView } from 'uniba-volto-persone/components';

/*  CONTENT TYPES VIEWS */
const addonContentTypesViews = {
  SchedaPersona: SchedaPersonaWrapperView,
  LRF: HomeView,
  Struttura: StrutturaView,
  "Plone Site": HomeView,
  //Document: PageView,
  //'News Item': NewsItemView,
};

/* LAYOUT VIEWS */
const addonLayoutViews = {
  rubrica_view: HomeView,
  struttura_view: HomeStrutturaView,
  //document_view: PageView,
};

const layoutViewsNamesMapping = {
  rubrica_view: 'Vista cerca Persone',
  struttura_view: 'Vista cerca Strutture',
  base_view: 'Vista Base',
  view: 'Vista di Default'
  //modulistica_view: 'Cartella modulistica',
};

const getAddonViews = (config) => {
  return {
    contentTypesViews: {
      ...config.views.contentTypesViews,
      ...addonContentTypesViews,
    },
    layoutViews: {
      ...config.views.layoutViews,
      ...addonLayoutViews,
    },
    layoutViewsNamesMapping: {
      ...config.views.layoutViewsNamesMapping,
      ...layoutViewsNamesMapping,
    },
  };
};

export default getAddonViews;
